





























import { Component, Vue } from 'vue-property-decorator';
import cambioscontrasenasperdidasModule from '@/store/modules/cambioscontrasenasperdidas-module';
import { cambioscontrasenasperdidas } from '@/shared/dtos/cambioscontrasenasperdidas';
import { UtilsString } from '@/utils/utils-string';

@Component
export default class PwdLost extends Vue {
  private objpwslost = new cambioscontrasenasperdidas();
  private verMensaje = false;
  private changePwdAutomatico = false;
  private loading = false;
  private error: string | null = null;

  created() {
    if (UtilsString.IsValidParamUrl(this.$route.params.email)) {
      this.changePwdAutomatico = true;
      this.objpwslost.email = this.$route.params.email;
      setTimeout(() => this.submit(), 250);
    }
  }

  private validateEmail(email: string): boolean {
    const re = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
    return re.test(email);
  }

  private async submit() {
    if (!this.validateEmail(this.objpwslost.email)) {
      this.error = 'Por favor, introduce un correo electrónico válido.';
      return;
    }
    this.error = null;
    this.loading = true;
    this.objpwslost.url_production = window.location.href.replace('lostpwd', '');
    try {
      await cambioscontrasenasperdidasModule.guardarcambioscontrasenasperdidas(this.objpwslost);
      this.verMensaje = true;
    } catch (e) {
      this.error = 'Ocurrió un error al procesar tu solicitud. Intenta nuevamente más tarde.';
    } finally {
      this.loading = false;
    }
  }
}
